import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as urls from '../utilities/urls';
import { NzTableData } from '../utilities/nz-table.adapter';
import { AuthService } from '../auth/auth.service';
import { VoucherIssuance, VouchersSearch } from '../models/voucher';

@Injectable({
  providedIn: 'root',
})
export class VouchersService {
  constructor(private httpClient: HttpClient, private router: Router, private authService: AuthService) { }

  // for Vouchers list

  //  getVouchersList(tableData: NzTableData<VouchersSearch, any>){ 
  //   const value={
  //   merchantId:tableData.search.merchantId,
  //   pageSize: tableData.pageSize,
  //   pageIndex: tableData.pageIndex,
  //   locationId:tableData.search.locationId,
  //   isAvailable:tableData.search.isAvailable,
  //   startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
  //   endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
  //   }
  //     return this.httpClient.get(urls.VouchersUrls.vouchersList,value);
  // }
  getVouchersList(args) {
    return this.httpClient.post(urls.VouchersUrls.vouchersList, args);
  }

  validateVoucher(args) {
    return this.httpClient.post(urls.VouchersUrls.voucherValidate, args);
  }

  redeeemVoucher(args) {
    return this.httpClient.post(urls.VouchersUrls.voucherRedeem, args);
  }

  // redeeemdVouchersList(args) {
  //   return this.httpClient.post(urls.VouchersUrls.voucherRedeemedList, args);
  // }

  redeeemdVouchersList(tableData: NzTableData<VoucherIssuance, any>) {
    const value = {
      appCode: tableData.search.appCode,
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex,
      voucherName: tableData.search.voucherName,
      code: tableData.search.code,
      redeemedMerchant: tableData.search.merchant,
      redeemedLocation: tableData.search.location ,
      status: 5,
    };
    return this.httpClient.post(urls.VouchersUrls.voucherRedeemedList, value);
  }


  redeeemdVouchersReport(args) {
    const value = {
      appCode: args.appCode,
      pageSize: args.pageSize,
      pageIndex: args.pageIndex,
      voucherName: args.voucherName,
      code: args.code,
      redeemedMerchant: args.redeemedMerchant,
      redeemedLocation: args.redeemedLocation ,
      status: 5,
    };
    return this.httpClient.post(urls.VouchersUrls.voucherRedeemedList, value);
  }

  // To Clear search fields
  clearSearchVoucherCodeFields(tableData: NzTableData<VoucherIssuance, any>, value) {
    if (value === 'code') {
      return tableData.search.code = '';
    }
    if (value === 'voucherName') {
      return tableData.search.voucherName = '';
    }
    if (value === 'location') {
      return tableData.search.location = '';
    }
    if (value === 'merchant') {
      return tableData.search.merchant = '';
    }
  }

  // To Clear search fields
  clearSearchVouchersFields(tableData: NzTableData<VouchersSearch, any>, value) {
    if (value === 'name') {
      return tableData.search.name = '';
    }

  }
}
